export default class PopoverManager {
    constructor(element) {
        this.element = element;
        this.eventDelegation();
    }

    eventDelegation() {
        this.element.querySelectorAll('[data-entity="popover"]').forEach((popover) => {
            if (popover.classList.contains('popover-initialized')) {
                return;
            }
            let backdrop = document.createElement('div');
            backdrop.classList.add('popover-backdrop');
            popover.appendChild(backdrop);
            popover.classList.add('popover-initialized');

            popover.addEventListener('click', () => {
                popover.classList.add('popover-active')
            });

            backdrop.addEventListener('click', (event) => {
                popover.classList.remove('popover-active');
                event.stopImmediatePropagation();
                event.preventDefault();
            });
        });
    }
}
